module.exports = __webpack_public_path__ + "static/media/Workday_Step2a_Image10.be13ebe1.jpg";